export default __webpack_public_path__ + "static/media/telegramWhite.68eaef7d.svg";